import api from '../lib/axios';
export const getProjects = (params) => api.get('/api/admin/projects', { params }).then((r) => r.data);
export const getProject = (id) => api.get(`/api/admin/projects/${id}`).then((r) => r.data);
export const createProject = (body) => api.post('/api/admin/projects', body).then((r) => r.data);
export const validateProject = (id) => api.patch(`/api/admin/projects/${id}/validate`);
export const rejectProject = (id, reason) => api.patch(`/api/admin/projects/${id}/reject`, { reason });
export const changeProjectState = (id, body) => api.patch(`/api/admin/projects/${id}/state`, body);
export const updateProjectBudget = (id, budget) => api.patch(`/api/admin/projects/${id}/budget`, { budget });
export const updateProjectProgress = (id, progress) => api.patch(`/api/admin/projects/${id}/progress`, { progress }).then((r) => r.data);
export const updateProjectResponse = (id, admin_response) => api.patch(`/api/admin/projects/${id}/response`, { admin_response });
export const PROJECT_CATEGORIES = ['environnement', 'urbanisme', 'culture', 'sport', 'solidarite', 'mobilite', 'numerique', 'autre'];
const PROJECT_CATEGORY_LABELS = {
    environnement: 'Environnement', urbanisme: 'Urbanisme', culture: 'Culture', sport: 'Sport',
    solidarite: 'Solidarité', mobilite: 'Mobilité', numerique: 'Numérique', autre: 'Autre',
};
export const projectCategoryLabel = (key) => PROJECT_CATEGORY_LABELS[key] ?? key;
export const deleteProject = (id) => api.delete(`/api/admin/projects/${id}`);
